module.exports = __webpack_public_path__ + "img/nodata_black.d39f8d1b.png";